// how-to-start/utils/template-source.ts
//
// WHERE THE TEMPLATE'S STORY COMES FROM.
//
// A template path used to mean one thing: a content pointer, the url of a
// story JSON to fetch. Storydoc's templates and the user's own documents both
// have one. A set of slides picked in the slides library does not -- it is
// assembled in the browser and exists nowhere else -- so the funnel also
// takes the story itself, in memory, and every step that used to fetch the
// pointer reads through here instead.

import { fetchTemplateStory } from "./fetch-template-story";

export type TemplateSourceInput = {
  /** Where a stored template's story lives. */
  templateContentPointer?: string | null;
  /** The story itself, when it was assembled rather than stored. */
  templateStory?: Record<string, unknown> | null;
};

/** Whether the funnel is building on a template at all. */
export const hasTemplateSource = (input: TemplateSourceInput): boolean =>
  Boolean(input.templateStory || input.templateContentPointer);

/**
 * The template's story, or null when there is no template. An in-memory story
 * wins over a pointer: it is already what the pointer would resolve to.
 */
export const readTemplateStory = async (
  input: TemplateSourceInput,
  fetch: (
    pointer: string,
  ) => Promise<Record<string, unknown>> = fetchTemplateStory,
): Promise<Record<string, unknown> | null> => {
  if (input.templateStory) return input.templateStory;
  if (input.templateContentPointer) return fetch(input.templateContentPointer);
  return null;
};
